import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { AdminJobUnreadRow } from '../types/admin_job_hub';

interface AdminHubStore {
  unreadByParticipant: AdminJobUnreadRow[];
  loadingUnread: boolean;
  error: string | null;

  reset: () => void;
  fetchAdminUnreadState: (jobId: string) => Promise<void>;
}

export const useAdminHubStore = create<AdminHubStore>(set => ({
  unreadByParticipant: [],
  loadingUnread: false,
  error: null,

  reset: () => {
    set({
      unreadByParticipant: [],
      loadingUnread: false,
      error: null,
    });
  },

  fetchAdminUnreadState: async (jobId: string) => {
    set({ loadingUnread: true, error: null });

    const { data, error } = await supabase.rpc('get_admin_job_unread_state', {
      p_job_id: jobId,
    });

    if (error) {
      set({ loadingUnread: false, error: error.message });
      return;
    }

    const unreadRows = (data ?? []) as AdminJobUnreadRow[];

    set({
      unreadByParticipant: unreadRows.map(r => ({
        profile_id: String(r.profile_id),
        first_name: r.first_name ?? null,
        last_name: r.last_name ?? null,
        unread_notification_count: Number(r.unread_notification_count) || 0,
      })),
      loadingUnread: false,
      error: null,
    });
  },
}));
